import http, { noneTokenHttp } from "../../utils/http";
import { toast } from "../../utils/toast";

export const getPartner = (companyIdx) => {
  return new Promise((resolve, reject) => {
    http
      .get(`/partner/${companyIdx}`)
      .then((res) => {
        resolve(res.data);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const getPartnerByCode = (code) => {
  return new Promise((resolve, reject) => {
    noneTokenHttp
      .get(`/partner/code/${code}`)
      .then((res) => {
        resolve(res.data);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const getPartners = (body) => {
  return new Promise((resolve, reject) => {
    noneTokenHttp
      .post(`/partner/list`, body)
      .then((res) => {
        resolve(res.data);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

// 파트너 정보 수정
export const modifyPartner = (idx, params) => {
  return new Promise((resolve, reject) => {
    http
      .put(`/partner/${idx}`, params)
      .then((res) => {
        // toast.success("파트너 정보가 변경 되었습니다.");
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

// 파트너 생성
export const createPartner = (params) => {
  return new Promise((resolve, reject) => {
    http
      .post(`/partner`, params)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

// 파트너 담당 세무사 요청
export const requestPartner = (companyIdx, taxCompanyCode) => {
  return new Promise((resolve, reject) => {
    http
      .put(`/partner/request-partner`, { companyIdx, taxCompanyCode })
      .then((res) => {
        toast.success("담당 세무사 요청 성공했습니다.");
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};



// 담당 세무사 요청 승인
export const requestPartnerApproved = (companyIdx) => {
  return new Promise((resolve, reject) => {
    http
      .put(`/partner/request-partner/${companyIdx}/state`,
        { state: 1 }
      )
      .then((res) => {
        toast.success("담당 세무사 요청을 승인했습니다.");
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};
// 담당 세무사 요청 거절
export const requestPartnerDenied = (companyIdx) => {
  return new Promise((resolve, reject) => {
    http
      .put(`/partner/request-partner/${companyIdx}/state`,
        { state: 0 }
      )
      .then((res) => {
        toast.warning("담당 세무사 요청을 거절했습니다.");
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};



// 등록요청 회사 목록 조회
export const getRequestPartnerCompanies = (params) => {
  return new Promise((resolve, reject) => {
    http
      .post(`/partner/request-partner/list`, params)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};